import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/cedulares/';

/**
 * GET Cedulas
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCedulas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Cedula
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getCedula = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Cedula
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postCedula = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cedula
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchCedula = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cedula
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteCedula = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Cedula
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosCedula = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Alcohol para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCedulaCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/cedular-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
